import axios from "axios";
import { headersProvider } from "../pages/utilities";

export const loginUser = async ({ email, password }) => {
  return axios
    .post(`${process.env.REACT_APP_API_MASTER_API}/email/service/user/sp-login`, {
      email,
      password,
    })
    .then((response) => {
      const data = response.data;
      if (!data.success) {
        return data;
      }
      return {
        success: true,
        token: data.result.token,
        user: data.result.user,
      };
    })
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const addUser = async ({
  email,
  password,
  enabled,
  role,
  businessUnit,
  name,
  department,
}) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/service-providers/new`,
      { email, password, enabled, role, businessUnit, name, department },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const updateUser = async ({ userData }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/edituser/${userData.id}`,
      { ...userData },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error updating user", error);
      throw error;
    });
};

export const addBu = async ({ name, enabled }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/addbu`,
      { name, enabled },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error adding bu", error);
      throw error;
    });
};

export const updateBuDetails = async ({ id, name, enabled }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/updateBu/${id}`,
      { name, enabled },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error updating bu", error);
      throw error;
    });
};

export const getBuData = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/getbudata`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu name", error);
      throw error;
    });
};

export const getBuList = async ({ page }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getbulist`,
      { page },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu list", error);
      throw error;
    });
};

export const getBuName = async ({ id }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_MASTER_API}/email/service/user/bu_name`,
      {
        bu_id: id,
      },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu name", error);
      throw error;
    });
};

export const getBuDetails = async ({ page, id }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getbudetails/${id}`,
      { page },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu list", error);
      throw error;
    });
};

export const getComplianceStatus = async ({ filters, page, pageSize }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getcomplaincestatus`,
      { filters, page, pageSize },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu list", error);
      throw error;
    });
};
export const fetchBuOptions = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_MASTER_API}/email/service/user/bu-list`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu options", error);
      throw error;
    });
};

export const fetchRegions = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/getregions`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("there was an error fetching regions", error);
    });
};
export const getMasterObligation = async ({ id }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/getMasterObligation/${id}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu options", error);
      throw error;
    });
};

export const deleteObligation = async ({ id }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/deleteMasterObligation/${id}`,
      {},
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu list", error);
      throw error;
    });
};

export const getTitlesOfAgreement = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/titlesofagreement`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu options", error);
      throw error;
    });
};
export const getNamesofAgreement = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/namesofagreement`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu options", error);
      throw error;
    });
};

export const getStandardObligations = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/getstandardobligations`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu options", error);
      throw error;
    });
};

export const getUserDetails = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_MASTER_API}/email/service/user/details`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Status:", error.response?.status);
      console.error("Data:", error.response?.data);
      console.error("Message:", error.message);
      throw error;
    });
};

export const getUserDept = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/getuserdept`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting user data", error);
      throw error;
    });
};
export const getDocuments = async ({ page, pageSize }) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_URL}/getdocuments`,
      { page, pageSize },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting documents data", error);
      throw error;
    });
};

export const getDepartmentTextApi = async ({ id }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getdepartmenttext`,
      { id },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting department text", error);
      throw error;
    });
};
export const getDepartmentNumberApi = async ({ name }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getdepartmentid`,
      { name },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting department id", error);
      throw error;
    });
};

export const getDepartmentListApi = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/getDepartmentList`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting department list", error);
      throw error;
    });
};

export const changeUserRole = async ({ roleId }) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_MASTER_API}/email/service/user/login-as/${roleId}`,
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error changing user role", error);
      throw error;
    });
};

export const getOrgDetailsFromMaster = async () => {
  return axios
    .post(
      `${process.env.REACT_APP_API_MASTER_API}/email/service/user/orgdetails`,
      { id: 1 },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error changing user role", error);
      throw error;
    });
};

export const getMyProfile = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/me`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error loading your profile", error);
      throw error;
    });
};

export const linkWhatsAppNumber = async ({ phone }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/me/phone`,
      { phone },
      { headers: headersProvider() },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error linking the WhatsApp number", error);
      throw error;
    });
};

export const getUsersByDepartment = async ({ department }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/getusersbydepartment/${department}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error fetching users by department", error);
      throw error;
    });
};
